import { deepCopy } from '@/utils'

function checkRadioData (data, originData) {
  let checkDetail = {
    noData: false,
    errTitle: '请输入选项'
  }
  const { q_category, q_is_required = 0, option } = originData
  if (q_category === data.q_category && q_is_required === 1) {
    if (!data.q_option_id) {
      checkDetail.noData = true
    } else {
      option.forEach(o_item => {
        const { o_id, o_has_input = 0 } = o_item
        if (o_id === data.q_option_id && o_has_input === 1 && !data.inputsValue[data.q_option_id]) {
          checkDetail.noData = true
          checkDetail.errTitle = '请输入文本框内容'
        }
      })
    }
  }
  return checkDetail
}

function checkMultiData (data, originData) {
  console.log('tag')
  let checkDetail = {
    noData: false,
    errTitle: '请输入选项'
  }
  if (!data.checkboxArr || data.checkboxArr.length === 0) {
    checkDetail.noData = true
  } else {
    let hasInputArr = []
    let hasValueInput = []
    originData.option.forEach(o_item => {
      if (o_item.o_has_input === 1) {
        hasInputArr.push(o_item.o_id)
      }
    })
    data.checkboxArr.forEach(item => {
      if (hasInputArr.includes(item)) {
        hasValueInput.push(item)
      }
    })
    hasValueInput.forEach(item => {
      if (!data.inputsValue[item]) {
        checkDetail.noData = true
        checkDetail.errTitle = '请输入文本框内容'
      }
    })
  }
  return checkDetail
}

function checkTextData (data, originData) {
  let checkDetail = {
    noData: false,
    errTitle: '请输入选项'
  }
  if (originData.q_category === data.q_category && originData.q_is_required === 1) {
    switch (data.q_property) {
      case 'int':
        if (data.q_answer_info % 1 === 0 && parseFloat(data.q_answer_info).toString() !== 'NaN') {
          const q_answer_info_num = Number(data.q_answer_info)
          let isRight = true
          if (data.relation === 'and') {
            isRight = (q_answer_info_num > data.min) && (q_answer_info_num < data.max) && (q_answer_info_num === data.equal) && (q_answer_info_num !== data.neq)
            if (!isRight) {
              if (q_answer_info_num !== data.equal && data.equal !== '' && data.equal != null) {
                checkDetail = { noData: true, errTitle: `请输入${data.equal}` }
              } else {
                if (q_answer_info_num === data.neq && data.neq !== '' && data.neq != null) {
                  checkDetail = { noData: true, errTitle: `输入不等于${data.neq}` }
                } else {
                  if (q_answer_info_num < data.min && data.min !== '' && data.min != null) {
                    checkDetail = { noData: true, errTitle: `输入最小值为${data.min}` }
                  } else if (q_answer_info_num > data.max && data.max !== '' && data.max != null) {
                    checkDetail = { noData: true, errTitle: `输入最大值为${data.max}` }
                  }
                }
              }
            }
          } else {
            isRight = (q_answer_info_num > data.min) || (q_answer_info_num < data.max) || (q_answer_info_num === data.equal) || (q_answer_info_num !== data.neq)
            if (!isRight) {
              if (q_answer_info_num !== data.equal && data.equal !== '' && data.equal != null) {
                checkDetail = { noData: true, errTitle: `请输入${data.equal}` }
              } else if (q_answer_info_num === data.neq && data.neq !== '' && data.neq != null) {
                checkDetail = { noData: true, errTitle: `输入不等于${data.neq}` }
              } else if (q_answer_info_num < data.min && data.min !== '' && data.min != null) {
                checkDetail = { noData: true, errTitle: `输入最小值为${data.min}` }
              } else if (q_answer_info_num > data.max && data.max !== '' && data.max != null) {
                checkDetail = { noData: true, errTitle: `输入最大值为${data.max}` }
              }
            }
          }
        } else {
          checkDetail = { noData: true, errTitle: '请输入整数' }
        }
        break
      case 'date':
        !data.q_answer_info ? checkDetail = { noData: true, errTitle: '请选择日期' } : checkDetail.noData = false
        break
      case 'time':
        !data.q_answer_info ? checkDetail = { noData: true, errTitle: '请选择时间' } : checkDetail.noData = false
        break
      default:
        !data.q_answer_info ? checkDetail.noData = true : checkDetail.noData = false
        break
    }
  }
  return checkDetail
}

function checkDropData (data, originData) {
  let checkDetail = {
    noData: false,
    errTitle: '请输入选项'
  }
  if (originData.q_category === data.q_category && originData.q_is_required === 1) {
    if (!data.q_option_id) {
      checkDetail.noData = true
    }
  }
  return checkDetail
}

function checkCascadeData (data, originData) {
  let checkDetail = {
    noData: false,
    errTitle: '请输入选项'
  }
  if (originData.q_category === data.q_category && originData.q_is_required === 1) {
    if (!data.firstCascade || !data.secondCascade) {
      checkDetail.noData = true
    }
  }
  return checkDetail
}

function formatData (data) {
  let arr = []
  let copyData = deepCopy(data)
  Object.values(copyData).forEach(item => {
    switch (item.q_category) {
      case 1:
        item.q_remark = item.inputsValue[item.q_option_id]
        delete item.inputsValue
        arr.push(item)
        break
      case 2:
        if (item.checkboxArr.length > 0) {
          let option = item.checkboxArr.map(items => {
            let slectOption = item.option.find(o_item => {
              const { o_id } = o_item
              if (o_id === items) {
                return o_item
              }
            })
            return {
              q_category: item.q_category,
              question_id: item.question_id,
              q_answer_info: item.q_answer_info,
              q_option_id: items,
              q_remark: item.inputsValue[items] || '',
              q_is_required: item.q_is_required,
              o_is_required: slectOption.o_is_required,
              o_has_input: slectOption.o_has_input,
              o_is_conflict: slectOption.o_is_conflict,
              data_datetime: item.data_datetime,
              remark: item.remark,
              q_number: item.q_number
            }
          })
          arr = arr.concat(option)
        }
        break
      case 5:
        item.option.forEach(c_item => {
          const { o_id } = c_item
          if (String(o_id) === String(item.firstCascade)) {
            arr.push({
              q_category: item.q_category,
              question_id: item.question_id,
              q_option_id: item.firstCascade,
              q_remark: item.q_remark,
              q_answer_info: item.q_answer_info,
              q_is_required: item.q_is_required,
              o_is_required: c_item.o_is_required,
              o_has_input: c_item.o_has_input,
              o_is_conflict: c_item.o_is_conflict,
              data_datetime: item.data_datetime,
              remark: item.remark,
              q_number: item.q_number
            })
          }
          c_item.son.forEach(o_item => {
            let { id } = o_item
            if (String(id) === String(item.secondCascade)) {
              arr.push({
                q_category: item.q_category,
                question_id: item.question_id,
                q_option_id: item.secondCascade,
                q_remark: item.q_remark,
                q_answer_info: item.q_answer_info,
                q_is_required: item.q_is_required,
                o_is_required: o_item.o_is_required,
                o_has_input: o_item.o_has_input,
                o_is_conflict: o_item.o_is_conflict,
                data_datetime: item.data_datetime,
                remark: item.remark
              })
            }
          })
        })
        break
      default:
        arr.push(item)
        break
    }
  })
  return arr
}
export {
  checkRadioData,
  checkMultiData,
  checkTextData,
  checkDropData,
  checkCascadeData,
  formatData
}
